<template>
  <div>
    <Loader :loading="loading" />

    <div class="relative overflow-hidden">
      <v-btn small class="simulate left mr-2">
        {{ count | numberWithSpaces }} активаций на сумму
        {{ Math.round(rewards) | numberWithSpaces }} сум
      </v-btn>

      <v-btn
        color="primary"
        small
        class="mr-2 left"
        @click="getActivationsList(false)"
        text
        >Обновить</v-btn
      >

      <v-btn @click="getExcel" small color="danger" class="mr-2 left" text
        >Экспорт excel
      </v-btn>

      <!-- dsad -->

      <v-btn
        color="warning"
        small
        class="mr-2 left"
        @click="openFilter = !openFilter"
        text
        >Календарь</v-btn
      >
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="cyan"
            class="left mr-2"
          >
            Фильтры по времени
          </v-btn>
        </template>

        <v-card>
          <v-radio-group v-model="countDay">
            <v-radio
              @change="setDay"
              label="Сегодня"
              color="primary"
              value="0"
            ></v-radio>

            <v-radio
              @change="setDay"
              label="Неделя"
              color="primary"
              value="6"
            ></v-radio>

            <v-radio
              @change="setDay"
              label="Месяц"
              color="primary"
              value="29"
            ></v-radio>

            <v-radio
              @change="setDay"
              label="Квартал"
              color="primary"
              value="89"
            ></v-radio>

            <v-radio
              @change="setDay"
              label="Год"
              color="primary"
              value="365"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </v-menu>

      <!-- dsad -->

      <v-btn
        @click="additionalFilter = !additionalFilter"
        small
        v-on="on"
        dark
        color="cyan"
        class="left mr-2"
      >
        дополнительные фильтры
      </v-btn>

      <!-- dsad -->

      <v-btn @click="clearRange" small color="danger" class="mr-2 left" text
        >Сбросить фильтры</v-btn
      >
    </div>

    <div class="relative overflow-hidden" style="margin-left: -20px">
      <v-switch
        @change="setIsNull"
        v-model="is_null"
        class="mx-2 left"
        label="Получившие 0"
      ></v-switch>

      <v-switch
        @change="setWithdraw"
        v-model="withdraw"
        class="mx-2 left"
        label="Вывели средства"
      ></v-switch>

      <v-switch
        @change="setNoConfirm"
        v-model="no_confirm"
        class="mx-2 left"
        label="Не одобренные"
      ></v-switch>

      <v-switch
        @change="setConfirmFilter"
        v-model="confirm"
        class="mx-2 left"
        label="Одобренные"
      ></v-switch>
    </div>

    <v-layout wrap v-if="additionalFilter" class="mb-3">
      <v-flex sm12 xs12 md6 xl4>
        <multiselect
          class="customer-select-style-temp"
          v-model="categorySelected"
          :options="categories"
          :multiple="true"
          group-values="subcategory"
          group-label="title"
          :group-select="true"
          placeholder="Фильтр по категориям"
          track-by="id"
          label="title"
          @input="setData"
        >
          <span slot="noResult">Нет такой категории</span>
        </multiselect>
      </v-flex>
      <v-flex sm12 xs12 md6 xl4>
        <multiselect
          class="customer-select-style-temp"
          v-if="brandFilter"
          v-model="brandSelected"
          :options="brands"
          :multiple="true"
          group-label="title"
          placeholder="Фильтр по  бренду"
          track-by="id"
          label="title"
          @input="setData"
        >
          <span slot="noResult">Нет такой категории</span>
        </multiselect>
      </v-flex>

      <v-flex sm12 xs12 md6 xl4>
        <multiselect
          class="customer-select-style-temp"
          v-model="regionSelected"
          :options="region"
          :multiple="true"
          placeholder="Фильтр по региону"
          track-by="id"
          label="title"
          @input="setRegion"
        >
          <span slot="noResult">Нет такой категории</span>
        </multiselect>
      </v-flex>

      <v-flex sm12 xs12 md6 xl4>
        <multiselect
          class="customer-select-style-temp"
          v-model="citySelected"
          :options="city"
          :multiple="true"
          :disabled="!city.length"
          placeholder="Фильтр по городу (району)"
          track-by="id"
          label="title"
          @input="setCity"
        >
          <span slot="noResult">Нет такой категории</span>
        </multiselect>
      </v-flex>

      <v-flex sm12 xs12 md6 xl4>
        <multiselect
          class="customer-select-style-temp"
          v-model="outletSelected"
          :options="outlet"
          :multiple="true"
          :disabled="!outlet.length"
          placeholder="Фильтр по торговой точке"
          track-by="id"
          label="title"
          @input="setOutlet"
        >
          <span slot="noResult">Нет такой категории</span>
        </multiselect>
      </v-flex>
    </v-layout>

    <div>
      <v-btn
        v-if="additionalFilter"
        @click="additionalFilter = !additionalFilter"
        small
        v-on="on"
        dark
        color="cyan"
        class="mb-4"
      >
        Скрыть фильтры
      </v-btn>
    </div>

    <div class="mb-2 mt-1" v-if="start_at || end_at">
      <span v-if="start_at">
        <b>С</b>
        {{ (start_at + " 00:00:00") | dateTime }}
      </span>
      <span v-if="end_at">
        <b>ДО</b>
        {{ (end_at + " 23:59:59") | dateTime }}
      </span>
    </div>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск..."
      class="sticky search"
      single-line
      hide-details
      :loading="loadingSearch"
      clearable="true"
    ></v-text-field>
    <v-data-table :headers="headers" :items="activationsList" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>
      <template v-if="item.options" slot="items" slot-scope="{ item }">
        <!--        
        <td class="text-xs-left">
          <span
            class="text-success"
            v-if="
              item.options.code && !item.administrators && !item.transaction
            "
            >Customer Service</span
          >
          <span class="text-success" v-else-if="item.administrators_confirm">{{
            item.administrators_confirm.name
          }}</span>
          <span class="error--text" v-else>Не одобрен</span>
        </td> -->

        <!-- <td class="text-xs-left min-width">
          <span
            v-if="item.reward < 0 && (item.transaction || item.administrators)"
          >
            <span class="error--text">Вывод средств</span>
          </span>
          <span
            class="text-success"
            v-else-if="
              item.reward > 0 && !item.transaction && !item.administrators
            "
            >Активация товара</span
          >
        </td> -->
        <td class="text-xs-left">
          <span
            v-if="!item.transaction && !item.administrators"
            :class="`${item.reward === 0 ? 'error--text' : ''}`"
          >
            {{
              item.options.product_info.vendor_code
                ? item.options.product_info.vendor_code
                : "Удален"
            }}

            /
            <small>
              {{ item.options.serial_number }}
              /
              {{
                item.options.product_info.name
                  ? item.options.product_info.name
                  : "Удален"
              }}</small
            >
            <br />
          </span>

          <span v-else>-</span>
        </td>

        <td class="text-xs-left">
          <span v-if="item.options.vendor">
            {{ item.options.vendor.name }}
          </span>
          <span v-else>Не установлен</span>
        </td>
        <td class="text-xs-left">
          {{ item.klient }}
        </td>

        <td class="text-xs-left">
          <span v-if="item.administrators">{{ item.administrators.name }}</span>
          <span v-else>Дилер</span>
        </td>

        <td class="text-xs-left min-width">
          <span
            v-if="
              item.reward == item.options.reward ||
              item.administrators ||
              item.transaction
            "
            >{{ item.reward | numberWithSpaces }} сум</span
          >

          <span v-else>
            <button @click="unsetZero(item)" class="user-link error--text">
              *** {{ item.reward | numberWithSpaces }} →
              {{ item.options.reward | numberWithSpaces }} сум
            </button>
          </span>
        </td>

        <td
          v-if="brandFilter"
          class="text-xs-left"
          @click="SET_USER(item.dealer_id)"
        >
          <small>{{ item.dealer.title }} {{ item.dealer.phone_number }} </small>
        </td>

        <td v-else class="text-xs-left">
          <small>{{ item.dealer.title }}</small>
          <br />
          {{ item.dealer.phone_number }}
        </td>

        <td>
          <small v-if="item.dealer.address && item.dealer.address.length">
            {{ item.dealer.address[0].language.title }}
            {{ item.dealer.address[0].region.language.title }}
          </small>
        </td>

        <td class="text-xs-right">{{ item.created_at | dateTime }}</td>

        <td class="text-xs-right">
          <v-menu open-on-hover left offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" fab color="cyan">
                <v-icon small dark> mdi-pencil </v-icon>
              </v-btn>
            </template>

            <v-card class="pl-2 pr-2" v-if="$store.state.role[3]">
              <span v-if="item.transaction || item.administrators">
                <v-btn
                  small
                  :disabled="item.administrators_confirm !== null"
                  color="success"
                  @click="setConfirm(item, 'accept')"
                  text
                  >Одобрить</v-btn
                >
                
                <br />
                <v-btn
                  small
        
                  color="danger"
                  @click="setConfirm(item, 'cancel')"
                  class="mr-2"
                  text
                  >Отменить</v-btn
                >
                <br />
              </span>
              <span v-else>
                <v-btn small :disabled="true" color="success" text
                  >Одобрить</v-btn
                >
                <br />
                <v-btn small :disabled="true" color="danger" text
                  >Отменить</v-btn
                >
                <br />
              </span>

              <v-btn v-if="item.reward>0" color="info" small @click="initNewBonus(item)" text
                >Изменить</v-btn
              >
            </v-card>
          </v-menu>
        </td>
      </template>
    </v-data-table>

    <div class="horizontal-scroll">
      <v-pagination
        v-if="last_page > 1"
        v-model="page"
        total-visible="20"
        class="my-4"
        :length="last_page"
      ></v-pagination>
    </div>

    <Dealer />
    <ProductCard />

    <div :class="`products-filters ${openFilter ? ' activeNow' : ''}`">
      <div class="products-filters-content">
        <div class="products-filters-content-view date">
          <div>
            <!--<v-radio-group v-model="resourceValue">-->
            <!--<v-radio-->
            <!--v-if="resourceValue"-->
            <!--@change="setResource"-->
            <!--label="Показать все"-->
            <!--color="primary"-->
            <!--value="0"-->
            <!--&gt;</v-radio>-->
            <!--<v-radio-->
            <!--@change="setResource"-->
            <!--v-for="res in resources"-->
            <!--:label="res.name"-->
            <!--color="secondary"-->
            <!--:value="res.id"-->
            <!--&gt;</v-radio>-->
            <!--</v-radio-group>-->
            <div>
              <h4>ДАТА НАЧАЛА</h4>

              <v-date-picker
                :dark="true"
                v-model="start_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
            <h4>ДАТА ОКОНАЧАНИЯ</h4>
            <div>
              <v-date-picker
                :dark="true"
                v-model="end_at"
                :landscape="false"
                locale="ru"
                :color="'primary'"
                :reactive="true"
                :full-width="true"
                :show-current="false"
                :multiple="false"
                :readonly="false"
                :disabled="false"
                @change="setRange"
              ></v-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="products-filters-control">
        <v-btn
          @click="clearRange"
          style="width: 100%"
          color="danger"
          class="mb-0"
          text
          >Сбросить все</v-btn
        >

        <v-btn
          style="width: 100%"
          color="primary"
          class="mb-0"
          @click="openFilter = false"
          text
          >Закрыть календарь</v-btn
        >
      </div>
    </div>

    <v-dialog
      width="400"
      persistent
      v-model="newBonusModal"
      transition="dialog-bottom-transition"
      v-if="newBonusObject"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Установка новых бонусов</div>

          <v-text-field
            v-model="newBonus"
            label="Введите бонусы"
          ></v-text-field>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="warning" text @click="setActivation">Применить</v-btn>
          <v-btn
            color="primary"
            text
            @click="
              newBonusObject = null;
              newBonusModal = false;
            "
            >Отмена</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="export_data.length"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Выгрузите экспорт</div>
          <br />
          <br />
          <download-excel
            v-if="export_data.length && loading === false"
            :data="export_data"
            :fields="json_fields_all_products"
            :name="'export_' + exportFileName"
          >
            <v-btn color="warning" text style="width: 100%">Скачать</v-btn>
          </download-excel>

          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn
            color="primary"
            text
            style="width: 100%"
            @click="export_data = []"
            >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";

import { mapMutations, mapState } from "vuex";
import Dealer from "../Dealer";
import ProductCard from "../ProductCard";

export default {
  name: "Activations",
  data: () => ({
    //export
    rewards: 0,
    exportFileName: "",
    json_fields_all_products: {
      "Серийный номер": "serial_number",
      "Наименование товара": "product_name",
      "Секретный код": "secret",
      Награда: "reward",
      Артикул: "product_vendor_code",
      Дилер: "dealer_name",
      "Номер телефона дилера": "dealer_phone",
      "Администратор (вывод средств)": "administrator",
      "Дата активации": "created_at",
      "Торговая точка": "outlet",
      "Номер магазина или адрес": "mark",
    },
    export_data: [],
    //export
    //filter regions
    region: [],
    city: [],
    outlet: [],
    regionSelected: [],
    citySelected: [],
    outletSelected: [],

    //SET CUSTOM NEW BONUS
    newBonus: null,
    newBonusObject: null,
    newBonusModal: false,
    additionalFilter: false,
    //filter regions

    categorySelected: [],
    brandSelected: [],
    countDay: 0,
    brandFilter: true,
    search: "",
    start_at: null,
    end_at: null,
    is_null: false,
    withdraw: false,
    no_confirm: false,
    confirm: false,
    count: 0,
    page: 1,
    last_page: 0,
    openFilter: false,
    openFilterProduct: false,
    searcher: null,
    loadingSearch: true,
    loading: true,
    headers: [
      // {
      //   sortable: false,
      //   text: "Ответсвтвенный",
      //   value: "code",
      // },
      // {
      //   sortable: false,
      //   text: "Вид действия",
      //   value: "product.title",
      // },
      {
        sortable: false,
        text: "Товар",
        value: "serial_number",
      },

      {
        sortable: false,
        text: "Отгрузка",
        value: "serial_number",
      },

      {
        sortable: false,
        text: "Партнер",
        value: "klient",
      },
      {
        sortable: false,
        text: "От",
        value: "administrators.name",
      },

      {
        sortable: false,
        text: "Сумма",
        value: "reward",
      },

      {
        sortable: false,
        text: "Дилер",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Адрес дилера",
        value: "dealer.address",
      },
      {
        sortable: false,
        text: "Дата активации / запроса",
        value: "created_at",
        align: "right",
      },

      {
        sortable: false,
        text: "Действие",
        align: "right",
        value: "product.vendor_code",
      },
    ],
    activationsList: [],
  }),
  components: { ProductCard, Dealer, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ACTIVATIONS", "SET_PRODUCT_CARD"]),

    getExcel() {
      this.loading = true;

      let vendorSet = null;
      if (this.brand) {
        vendorSet = Object.keys(this.brand).join("-");
      }

      axios(
        // .get("excel/activations-dealer", {
        //   params: {
        //     search: this.search,
        //     start_at: this.start_at,
        //     end_at: this.end_at,
        //     is_null: this.is_null === true ? 1 : 0,
        //     withdraw: this.withdraw === true ? 1 : 0,
        //     no_confirm: this.no_confirm === true ? 1 : 0,
        //     confirm: this.confirm === true ? 1 : 0,
        //     category_id: this.selectedCategory,
        //     brand_id: this.selectedBrand,
        //     region: this.selectedRegion,
        //     city: this.selectedCity,
        //     outlet: this.selectedOutlet
        //   }
        // }
        {
          method: "GET",
          url: "excel/activations-dealer",
          responseType: "blob",
          params: {
            search: this.search,
            start_at: this.start_at,
            end_at: this.end_at,
            is_null: this.is_null === true ? 1 : 0,
            withdraw: this.withdraw === true ? 1 : 0,
            no_confirm: this.no_confirm === true ? 1 : 0,
            confirm: this.confirm === true ? 1 : 0,
            category_id: this.selectedCategory,
            brand_id: vendorSet ? vendorSet : this.selectedBrand,
            region: this.selectedRegion,
            city: this.selectedCity,
            outlet: this.selectedOutlet,
          },
        }
      )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "activations.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        });
    },

    openExport() {
      this.exportFileName = "activations_dealer.xls";
      this.loading = true;

      if (this.brand) {
        vendorSet = Object.keys(this.brand).join("-");
      }

      setTimeout(() => {
        axios
          .get("admin/export/activations-dealer", {
            params: {
              search: this.search,
              start_at: this.start_at,
              end_at: this.end_at,
              is_null: this.is_null === true ? 1 : 0,
              withdraw: this.withdraw === true ? 1 : 0,
              no_confirm: this.no_confirm === true ? 1 : 0,
              confirm: this.confirm === true ? 1 : 0,
              category_id: this.selectedCategory,
              brand_id: vendorSet ? vendorSet : this.selectedBrand,
              region: this.selectedRegion,
              city: this.selectedCity,
              outlet: this.selectedOutlet,
            },
          })
          .then(async (response) => {
            this.export_data = await response.data;
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          });
      }, 100);
    },

    getActivationsList(noLoading) {
      if (!noLoading) this.loading = true;

      let vendorSet = null;

      if (this.brand) {
        vendorSet = Object.keys(this.brand).join("-");
        if (vendorSet) {
          this.brandFilter = false;
        }
      }

      axios
        .get("admin/activations-dealer", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
            start_at: this.start_at,
            end_at: this.end_at,
            is_null: this.is_null === true ? 1 : 0,
            withdraw: this.withdraw === true ? 1 : 0,
            no_confirm: this.no_confirm === true ? 1 : 0,
            confirm: this.confirm === true ? 1 : 0,
            category_id: this.selectedCategory,
            brand_id: vendorSet ? vendorSet : this.selectedBrand,
            //filter
            region: this.selectedRegion,
            city: this.selectedCity,
            outlet: this.selectedOutlet,
          },
        })
        .then((response) => {
          this.SET_BADGE_ACTIVATIONS(0);
          this.activationsList = response.data.data;

          if (this.page == 1) {
            this.rewards = response.data.rewards;
          }
          this.last_page = response.data.last_page;
          this.count = response.data.total;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
          this.loadingSearch = false;
        });
    },
    setRange() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
    clearRange() {
      this.city =
        this.citySelected =
        this.outlet =
        this.outletSelected =
        this.regionSelected =
          [];
      this.withdraw = this.is_null = this.no_confirm = this.confirm = false;
      this.page = 1;
      this.search = "";
      this.start_at = this.end_at = null;
      this.countDay = 0;
      this.categorySelected = [];
      this.brandSelected = [];
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
    setDay() {
      this.page = 1;
      setTimeout(() => {
        let now = new Date(Date.now());
        let today = this.setZero(now.getDate());
        let month = this.setZero(now.getMonth() + 1);
        let year = now.getFullYear();
        if (!this.countDay) {
          this.countDay = 0;
        }
        let endDate = Date.now() - this.countDay * 24 * 3600 * 1000;
        let startNow = new Date(endDate);
        let todayNow = this.setZero(startNow.getDate());
        let monthNow = this.setZero(startNow.getMonth() + 1);
        let yearNow = startNow.getFullYear();
        this.start_at = yearNow + "-" + monthNow + "-" + todayNow;
        this.end_at = year + "-" + month + "-" + today;
      }, 20);

      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
    setConfirm(item, type) {
      this.$dialog
        .confirm(
          "Вы уверены, что хотите совершить действие " +
            (type == "cancel"
              ? "УДАЛЕНИЯ транзации и стать отвественным лицом?"
              : "ПОДТВЕРЖДЕНИЯ транзации и стать отвественным лицом действия?"),
          {
            okText: "Продолжить",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          axios
            .post("admin/activations/confirm", {
              id: item.id,
              type: type,
              dealer_id: item.dealer_id,
            })
            .then((response) => {
              if (response.data.ok) {
                this.$toast.success({
                  title: "Успешно обновили",
                  message: response.data.success,
                });
              } else {
                this.$toast.error({
                  title: "Внимание!",
                  message: response.data.success,
                });
              }
            })
            .catch((error) => {
              this.$toast.error({
                title: "Ошибка",
                message: "Свяжитесь с администратором сайта",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.getActivationsList();
              }, 100);
            });
        })
        .catch(() => {});
    },

    setIsNull() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setWithdraw() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setNoConfirm() {
      this.confirm = 0;
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setConfirmFilter() {
      this.no_confirm = 0;
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setData() {
      this.page = 1;
      this.search = "";
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },

    setZero(val) {
      if (val <= 9) {
        val = "0" + val;
      }
      return val;
    },
    unsetZero(item) {
      this.$dialog
        .confirm("Вы точно хотите изменить награду и применить новую??", {
          okText: "Да, хочу",
          cancelText: "Отмена",
        })
        .then(() => {
          this.loading = true;
          axios
            .put("admin/activations/set-zero", {
              option_id: item.options ? item.options.id : null,
              dealer_id: item.dealer_id,
            })
            .then((response) => {
              this.$toast.success({
                title: "Успешно обновили бонус",
                message: "Пользователь получил новую сумму",
              });
            })
            .catch((error) => {
              this.$toast.error({
                title: "Ошибка",
                message: "Отправьте сериный номер товара администратору сайта",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.getActivationsList();
              }, 100);
            });

          this.tg({
            object: "#ativationsChangeReward",
            id: item.options.id,
            serial_number: item.options.serial_number,
            new_reward: item.options.reward,
            old_reward: item.reward,
          });
        })
        .catch(() => {});
    },

    tg(obj) {
      let message = JSON.stringify(obj);
      axios.post("notify/telegram", {
        message: message,
      });
    },

    //filter
    getRegion() {
      axios
        .get("admin/locations/list", {
          params: {},
        })
        .then((response) => {
          this.region = response.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },

    setRegion() {
      this.city = this.citySelected = this.outlet = this.outletSelected = [];
      axios
        .get("admin/locations/list", {
          params: {
            region: this.selectedRegion,
            is_city: 1,
          },
        })
        .then((response) => {
          this.city = response.data;
        })
        .catch((error) => {})
        .finally(() => {});

      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 100);
    },
    setCity() {
      this.outlet = this.outletSelected = [];
      axios
        .get("admin/locations/outlet", {
          params: {
            region: this.selectedRegion,
            city: this.selectedCity,
          },
        })
        .then((response) => {
          this.outlet = response.data;
        })
        .catch((error) => {})
        .finally(() => {});

      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 100);
    },
    setOutlet() {
      this.page = 1;
      setTimeout(() => {
        this.getActivationsList();
      }, 100);
    },
    initNewBonus(object) {
      if (object) {
        console.log("dsadasdas");
        console.log(object);
        this.newBonusObject = object;
        this.newBonus = object.reward;
        this.newBonusModal = true;
      }
    },
    setActivation() {
      console.log("1111111");
      console.log(this.newBonusObject);
      this.$dialog
        .confirm("Вы точно хотите изменить награду и применить новую?", {
          okText: "Да, хочу",
          cancelText: "Отмена",
        })
        .then(() => {
          this.loading = true;
          axios
            .put("admin/activations/set", {
              id: this.newBonusObject.id,
              reward: this.newBonus,
            })
            .then((response) => {
              this.$toast.success({
                title: "Успешно обновили бонус",
                message: "Пользователь получил новую сумму",
              });
              this.newBonusModal = false;
              this.newBonusObject = null;
            })
            .catch((error) => {
              this.$toast.error({
                title: "Ошибка",
                message: "Отправьте сериный номер товара администратору сайта",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.getActivationsList();
              }, 100);
            });

          this.tg({
            object: "#ativationsChangeReward",
            id: this.newBonusObject.options.id,
            serial_number: this.newBonusObject.options.serial_number,
            new_reward: this.newBonus,
            old_reward: this.newBonusObject.reward,
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getRegion();
    this.getActivationsList();
  },
  computed: {
    ...mapState(["categories", "brands", "brand"]),
    selectedCategory: {
      get() {
        if (this.categorySelected.length) {
          let category = [];
          for (let i = 0; i < this.categorySelected.length; i++) {
            category.push(this.categorySelected[i].id);
          }
          return category.length ? category.join("-") : "";
        }
        return "";
      },
    },
    selectedBrand: {
      get() {
        if (this.brandSelected.length) {
          let brand = [];
          for (let i = 0; i < this.brandSelected.length; i++) {
            brand.push(this.brandSelected[i].id);
          }
          return brand.length ? brand.join("-") : "";
        }
        return "";
      },
    },

    //filter regions

    selectedRegion: {
      get() {
        if (this.regionSelected.length) {
          let region = [];
          for (let i = 0; i < this.regionSelected.length; i++) {
            region.push(this.regionSelected[i].id);
          }
          return region.length ? region.join("-") : "";
        }
        return "";
      },
    },
    selectedCity: {
      get() {
        if (this.citySelected.length) {
          let city = [];
          for (let i = 0; i < this.citySelected.length; i++) {
            city.push(this.citySelected[i].id);
          }
          return city.length ? city.join("-") : "";
        }
        return "";
      },
    },
    selectedOutlet: {
      get() {
        if (this.outletSelected.length) {
          let outlet = [];
          for (let i = 0; i < this.outletSelected.length; i++) {
            outlet.push(this.outletSelected[i].id);
          }
          return outlet.length ? outlet.join("-") : "";
        }
        return "";
      },
    },

    //filter regions
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getActivationsList(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    },
  },
};
</script>

<style>
button.simulate {
  pointer-events: none;
  background: transparent !important;
  color: #222 !important;
  text-align: left !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.customer-select-style-temp {
  margin-bottom: 15px;
  max-width: calc(100% - 15px);
}
</style>
